import { axiosInstance as request } from '@api/rest.service'

const api = '/stakeholders'

/**
 * @description GET /stakeholders
 * @returns {AxiosPromise<any>}
 */
export const GET_STAKEHOLDERS = includes => {
  if (!includes) return request.get(api)
  return request.get(`${api}?include=${includes}`)
}

/**
 * @description POST /stakeholders
 * @returns {AxiosPromise<any>}
 */
export const CREATE_STAKEHOLDER = payload => request.post(api, payload)

/**
 * @description PUT /stakeholders/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_STAKEHOLDER = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /stakeholders/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_STAKEHOLDER_DELETE_CONFIRMATION = id => request.get(`${api}/${id}`)

/**
 * @description DELETE /stakeholders/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_STAKEHOLDER = id => request.delete(`${api}/${id}`)

/**
 * @description GET /stakeholders/replace/{param}/{param}
 * @returns {AxiosPromise<any>}
 */
export const REPLACE_STAKEHOLDER = (fromId, toId) => request.get(`${api}/replace/${fromId}/${toId}`)
